import React from 'react';
import type { StockStatus } from '../../types/product';
const copy: Record<StockStatus, {
  short: string;
  long: string;
  dot: string;
  text: string;
}> = {
  'in-stock': {
    short: 'Op voorraad · morgen in huis',
    long: 'Op voorraad — vóór 22:00 besteld, morgen in huis',
    dot: 'bg-success',
    text: 'text-success'
  },
  low: {
    short: 'Nog 4 op voorraad',
    long: 'Nog 4 op voorraad — vóór 22:00 besteld, morgen in huis',
    dot: 'bg-amber-500',
    text: 'text-amber-700'
  },
  preorder: {
    short: 'Pre-order · levering 12 nov',
    long: 'Pre-order — leverbaar vanaf 12 november',
    dot: 'bg-sky-600',
    text: 'text-sky-700'
  }
};
export function StockLabel({
  status,
  long = false
}: {
  status: StockStatus;
  long?: boolean;
}) {
  const c = copy[status];
  return <p className={`flex items-center gap-1.5 text-xs font-medium ${c.text}`} data-id="element-521" data-mp="go9b1stn55g5">
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${c.dot}`} aria-hidden="true" data-id="element-522" data-mp="1e580j3g5y2s2" />
      {long ? c.long : c.short}
    </p>;
}